import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';

import classNames from 'classnames';

import Label from 'components/Label';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {buildRoomTypeSelectizeOption} from 'components/Fields/SelectRoomTypeField';
import {
  TextField,
  DateField,
  SelectRoomTypeField,
  CheckBoxField
} from 'components/Fields';

import {MODALS} from 'ducks/allocations';
import {fetchRoomTypes, createRoom} from 'ducks/rooms';
import {selectModal} from 'ducks/modals';

import {headOption} from 'utils/common';
import {formatDateForApi} from 'utils/datetime';
import {required, validDate} from 'utils/validators';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {roomType, floor, roomNumber, creationDate, dummyRoom} = values;
  const {locationRef} = props;
  const creationDateInRightFormat = formatDateForApi(creationDate);
  const roomTypeId = _.get(roomType, 'object.id');

  dispatch(
    createRoom(
      {
        roomType: roomTypeId,
        floor,
        roomNumber,
        creationDate: creationDateInRightFormat,
        locationRef,
        dummy: dummyRoom
      },
      props.getExtraActions()
    )
  );
};

class CreateRoomForm extends React.Component<any> {
  componentDidMount() {
    const {locationRef} = this.props;

    const fetchRoomTypesExtraActions = this.props.storeDataExtraActions(
      data => ({
        roomTypes: data
      })
    );

    this.props.fetchRoomTypes({locationRef}, fetchRoomTypesExtraActions);
  }

  render() {
    const {className, handleSubmit, error, roomTypes} = this.props;
    return (
      <form
        onSubmit={handleSubmit}
        className={classNames(className, 'CreateRoomForm')}>
        {error && <ErrorBlock>{error}</ErrorBlock>}

        <FormField>
          <Label>Room Type</Label>
          <SelectRoomTypeField
            groupedRoomTypes={roomTypes}
            validate={[required]}
          />
        </FormField>
        <FormField>
          <Label>Room Number</Label>
          <Field
            name="roomNumber"
            className="CreateRoomForm__roomNumber"
            component={TextField}
            validate={[required]}
          />
        </FormField>
        <FormField>
          <Label>Floor</Label>
          <Field
            name="floor"
            className="CreateRoomForm__floor"
            component={TextField}
            validate={[required]}
          />
        </FormField>
        <FormField>
          <Label>Creation Date</Label>
          <Field
            name="creationDate"
            className="CreateRoomForm__creationDate"
            component={DateField}
            validate={[validDate]}
          />
        </FormField>
        <FormField>
          <Field
            name="dummyRoom"
            component={CheckBoxField}
            label="Dummy room"
          />
        </FormField>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const modal = selectModal(state, MODALS.CREATE_ROOM);

  const groupedRoomTypes = _.get(modal, 'data.roomTypes', []);
  const roomTypes = _.flatten(
    groupedRoomTypes.map(roomTypeGroup => roomTypeGroup.roomTypes)
  );

  const selectedRoomType = headOption(roomTypes, buildRoomTypeSelectizeOption);

  return {
    initialValues: {
      roomType: selectedRoomType
    },
    roomTypes: groupedRoomTypes
  };
};

const mapDispatchToProps = {
  fetchRoomTypes
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'createRoom',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(CreateRoomForm)
);
